import { getLocalStorageItem } from "src/services/localStorage";

// Written by Internal Dashboard > HTTP headers; apolloClient sends every entry as a header.
export const CUSTOM_HEADERS_STORAGE_KEY = "teamform_apollo_custom_headers";
export const FEATURE_FLAGS_HEADER = "x-feature-flags";

export type FeatureFlags = Record<string, unknown>;

/** Boolean overrides from the stored x-feature-flags header; {} if absent or malformed. */
export const readFeatureFlagOverrides = (): Record<string, boolean> => {
  const headers = getLocalStorageItem(CUSTOM_HEADERS_STORAGE_KEY);
  const raw = headers?.[FEATURE_FLAGS_HEADER];
  if (typeof raw !== "string" || !raw) {
    return {};
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return {};
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return {};
  }
  return Object.fromEntries(
    Object.entries(parsed).filter(([, value]) => typeof value === "boolean")
  ) as Record<string, boolean>;
};

/**
 * Same rule as the API's getFeatureFlagOverrides: only flags it returns with a
 * boolean value can be overridden, so the UI and API agree on every flag.
 */
export const applyFeatureFlagOverrides = (
  featureFlags: FeatureFlags | null | undefined,
  overrides: Record<string, boolean>
): FeatureFlags | null | undefined => {
  if (!featureFlags) {
    return featureFlags;
  }
  const applicable = Object.entries(overrides).filter(
    ([flag, value]) =>
      typeof featureFlags[flag] === "boolean" && featureFlags[flag] !== value
  );
  if (applicable.length === 0) {
    return featureFlags;
  }
  return { ...featureFlags, ...Object.fromEntries(applicable) };
};
